<template>
  <div class="divmain">
    <div id="container" style="width:100%;height:700px"></div>
  </div>
</template>

<script>
import { getCitsCompany } from "@/api/ayv3/base";
export default {
  name: "mdmap",
  components: {

  },
  data() {
    return {
      activeName: 'd_0',
      loading: true,
      cc_group: []
    }
  },
  methods: {
    //取门店
    getCitsCompany() {
      var map = {};
      getCitsCompany({}).then(res => {
        if (res.data.code === 0) {
          this.cc_group.push(...res.data.data);
          this.loading = false;
          this.showMap();
        } else {
          this.$alert(res.data.message, '提示');
        }
      })
    },
    showMap() {
        var map = new AMap.Map('container', {
          zoom:11,//级别
          center: [121.553083,29.872662],//中心点坐标
          viewMode:'3D'//使用3D视图
      });
      
      for (var i = 0; i < this.cc_group.length; i++) {
             var marker = new AMap.Marker({
                  position: new AMap.LngLat(this.cc_group[i].cits_company_longitude,this.cc_group[i].cits_company_latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                  title: this.cc_group[i].cits_company_title
              });
              map.add(marker);
          }
      

    }
  },
  mounted() {
    this.getCitsCompany();
  }
};
</script>
<style lang="less">
.box-card {
  float: left;
  width: 100%;
  max-width: 250px;
  height: 200px;
  margin: 0 20px 20px 0;
  .text_item {
    i {
      font-size: 18px;
    }
  }
}
.box-card_flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-star;
  .text_item {
    i {
      font-size: 18px;
    }
  }
}
</style>

